import type { AllFilterType } from '@carrefour-gcs/shared';

export interface TreeViewItemType {
  checkedStatus: CheckedStateType;
  label: string;
  filterKey: string;
  type: AllFilterType;
  children: TreeViewItemType[];
  disabled?: boolean;
  disabledMessage?: string;
  nodeId: string;
}

export interface TreeStateType {
  getParent(nodeId: string): TreeViewItemType | undefined;
  setParent(nodeId: string, parentItem: TreeViewItemType): void;
  getNodeCheckState(nodeId: string): CheckedStateType;
  emitItemCheckedChange(node: TreeViewItemType): void;
}

export interface ItemChangeEventType {
  itemId: string;
  change: ItemStateType;
}

export interface ItemStateType {
  filterType: AllFilterType;
  nodeId: string;
  state?: CheckedStateType;
  label?: string;
}
export interface TreeItemsStateType {
  [itemId: string]: ItemStateType;
}

export interface UseGraphType {
  treeItems: TreeViewItemType[];
  onItemsChecked: (state: TreeItemsStateType) => void;
  onItemChecked: (args: ItemChangeEventType) => void;
}

export const CHECKISH_STATES = ['checked', 'checked-by-parent'] as const;

export type CheckedStateType = 'checked' | 'checked-by-parent' | 'unchecked' | 'indeterminate';
